"use client";

import React, { useEffect } from "react";
import Footer from "@components/page/footer/Footer";
import { FooterContainer } from "@helpers/style/global.styles";
import { Box, Modal, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import {
  PageWrapper,
  HeroSection,
  ContentArea,
  HeaderContainer,
  FormContainer,
  InfoBlock,
  FAQBlock,
  LandscapeLogoContainer,
} from "@components/campaigns/free-report.styles";
import FAQAccordion from "../components/common/FAQAccordion";
import { faqData } from "../data/faq";
import cookies from "js-cookie";

const Screen: React.FC = () => {
  const [open, setOpen] = React.useState(false);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    const existingCookie = cookies.get("t3.landing");
    if (!existingCookie) {
      cookies.set("t3.landing", "free-report", { expires: 30 });
    }
  }, []);

  return (
    <PageWrapper>
      <Modal
        open={open}
        onClose={handleClose}
        sx={{
          margin: "auto",
          maxWidth: "100%",
          padding: "4vh",
          boxShadow: (theme) => theme.shadows[5],
        }}
      >
        <Box
          bgcolor="background.paper"
          sx={{
            margin: "auto",
            padding: "0.5vh 2vh 2vh 2vh",
            borderRadius: 1.25,
            textAlign: "center",
          }}
        >
          <h2>Without any obligations.</h2>
          <p>
            We will prepare a free test for the product recommended above.
            <br />
            If you feel it will effectively help your product develop, you can
            request our service according to our packages below.
            <br />
            <br />
          </p>
          <InfoBlock>
            <div className="info left">
              <h3>Learn more about TestTheTest</h3>
              <p>
                <strong>
                  TestTheTest is an easy-to-use online testing platform for your
                  app&apos;s better version.
                </strong>{" "}
                Catch regressions with our flexible plans! It&apos;s the best of
                both worlds: Accurate as manual testing should be. Cheap and
                fast like automations are.
                <br />
                <br />
                <strong>
                  At TestTheTest, we believe that dev teams should write code
                  test-driven, run automated tests on CI.
                </strong>{" "}
                The best testing is using the app like users do, and make sure
                all features are tested end-to-end.
              </p>
            </div>

            <div className="info right">
              <h3>Register without any obligations</h3>
              <p>
                Once we can access your app, you&apos;ll have your reports
                within the week. No code access, no onboarding, no integration
                or &quot;quick meeting&quot; — just your results. We caught bugs
                caused by simple Node and Python package updates — because who
                else would think to test the forgotten password flow again?
                <br />
                <br />
                We will prepare a free test for the product recommended above.
                If you feel it will effectively help your product develop, you
                can request our service according to our packages below.
              </p>
            </div>
          </InfoBlock>
          <FAQBlock>
            <div id="faq">
              <FAQAccordion items={faqData} />
            </div>
          </FAQBlock>
        </Box>
      </Modal>

      <HeroSection>
        <ContentArea>
          <HeaderContainer>
            <a className="navbar-brand" href="/">
              <LandscapeLogoContainer>
                <img
                  src="/assets/images/logo-horizontal.svg"
                  alt="Autonomous QA for web, mobile and desktop apps"
                />
              </LandscapeLogoContainer>
            </a>
          </HeaderContainer>

          <FormContainer>
            <div id="FormInfo">
              <Typography variant="h1">
                Unbiased QA. One Fixed Price.
              </Typography>
              <p>TestTheTest is a web testing service based in London.</p>
              <p>
                All it takes to start is a link to your app; once you sign up
                here, your completed bug report arrives within three working
                days.
              </p>
              <p>
                <strong>
                  Try it for free. If you like it, keep testing for $390/month.
                </strong>
              </p>
              <p className="checkitem">
                <CheckIcon /> End-to-end software testing, verified by an expert
                QA team
              </p>
              <p className="checkitem">
                <CheckIcon /> &quot;Black box&quot; testing. No vendor
                integration or technical setup needed.
              </p>
              <p className="checkitem">
                <CheckIcon /> Flat-rate pricing, no hidden costs, no lengthy
                contracts.
              </p>
              <p>
                <strong>
                  Questions?{" "}
                  <a href="mailto:signup@testthetest.com">Drop us a message.</a>
                </strong>
              </p>
            </div>
          </FormContainer>
        </ContentArea>
      </HeroSection>

      <FooterContainer>
        <Footer />
      </FooterContainer>
    </PageWrapper>
  );
};

export default Screen;
